import Dropdown, { DropdownItem } from '../../../../../UI/Dropdown/Dropdown'

type Props = {
  label: string
  value: string
  items: DropdownItem[]
  onChange?: false | ((value: string) => void)
  suffix?: string
  decimal?: boolean
  disabled?: boolean
}

const ValueDropdown: React.FC<Props> = ({ label, items, value, onChange }) => {
  return (
    <div className="flex gap-5 items-center justify-between">
      <div className="font-light text-md text-nowrap">{label}</div>
      <div className="w-1/2">
        {!onChange && <div className="text-md text-gray">{items.find((item) => item.value === value)?.label}</div>}
        {!!onChange && <Dropdown value={value} items={items} onChange={onChange} />}
      </div>
    </div>
  )
}

export default ValueDropdown
